import { RefObject, useEffect } from 'react';
import { scrollToId, scrollToIdWithMargin } from '../utils/scrollToId';
import { usePartnerStore } from '../state/Partner/usePartnerStore';

type TUseScrollIntoViewProps = {
    elementRef: RefObject<HTMLDivElement>;
    scrollable: boolean;
    enableScroll?: boolean;
};

export const useScrollIntoView = ({
    elementRef,
    scrollable,
    enableScroll = true,
}: TUseScrollIntoViewProps) => {
    const { isLightframePage } = usePartnerStore();

    useEffect(() => {
        if (!enableScroll) return;

        if (scrollable) {
            isLightframePage
                ? scrollToId('calendar-viewport', 'start')
                : scrollToIdWithMargin('calendar-viewport');
        }
    }, [elementRef, enableScroll, scrollable, isLightframePage]);
};
